import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { DxDataGridModule, DxTemplateModule } from "devextreme-angular";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { PanelsModule } from "src/app/shared/panels/panels.module";
import { FocusingModule } from "src/app/shared/ui/forms/inputs/focusing.module";
import { Select2Module } from "src/app/shared/ui/forms/inputs/oops-select2/select2.module";
import { UiModule } from "src/app/shared/ui/ui.module";
import { InsightCommentDetailComponent } from "./detail/comment-detail.component";
import { CommentDetailDirective } from "./detail/comment.directive";
import { InsightDetailCommentComponent } from "./insight-detail-comment.component";
import { InsightCommentTableComponent } from "./table/comment-table.component";

@NgModule({
    declarations: [
        InsightDetailCommentComponent,
        InsightCommentDetailComponent,
        InsightCommentTableComponent,
        CommentDetailDirective
    ],
    exports: [
        InsightDetailCommentComponent,
        InsightCommentDetailComponent,
        InsightCommentTableComponent,
        CommentDetailDirective
    ],
    imports: [
        ButtonsModule,
        CollapseModule,
        CommonModule,
        FocusingModule,
        FormsModule,
        DxDataGridModule,
        DxTemplateModule,
        MatIconModule,
        PanelsModule,
        Select2Module,
        UiModule
    ],
    providers: []
})
export class CommentModule {    
}